import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate as useHistory } from 'react-router-dom'

import { dialogSize, getRoute, routePaths } from '../../../../constants'
import { createScenario } from '../../../../actions'
import { checkErrorResponse, Logger, LoggerTypes } from '../../../../utils'
import { DialogFormEdit } from '../../../../components'
import { ScenarioForm } from '../ScenarioForm'

export const ScenarioDialogCreate = ({ openDialog, setOpenDialog }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const params = useParams()
  const navigateTo = useHistory()
  const { t } = useTranslation()

  // -- get projectID from URL.
  const { pid } = params

  const onDispatchAction = (newVar, _onSuccess, _onFail) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogCreate.onDispatchAction()', { newVar })

    dispatch(createScenario(pid, newVar))
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogCreate.dispatch(createScenario()).then()', {
          res
        })

        const newScenario = res?.data || {}

        if (newScenario.id) {
          if (_onSuccess && typeof _onSuccess === 'function') {
            _onSuccess(newScenario)
          }

          navigateTo(getRoute(routePaths.SCENARIO_FLOW_GROUPS, { pid, sid: newScenario.id }))
        } else {
          enqueueSnackbar(t('common.api_failure'), newScenario)

          if (_onFail && typeof _onFail === 'function' && res?.response?.data?.fields) {
            _onFail(res?.response?.data?.fields)
          }
        }
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'ScenarioDialogCreate.dispatch(createScenario()).catch()', {
          res
        })

        checkErrorResponse(res, enqueueSnackbar, t)

        if (_onFail && typeof _onFail === 'function' && res?.response?.data?.fields) {
          _onFail(res.response.data.fields)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'ScenarioDialogCreate.render()')

  return (
    <DialogFormEdit openDialog={openDialog} setOpenDialog={setOpenDialog} maxWidth={dialogSize.EXTRA_SMALL}>
      <ScenarioForm
        title={t('scenarios.title')}
        setOpenDialogVariable={setOpenDialog}
        dispatchAction={onDispatchAction}
      />
    </DialogFormEdit>
  )
}

ScenarioDialogCreate.displayName = 'ScenarioDialogCreate'

ScenarioDialogCreate.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  title: PropTypes.string
}

ScenarioDialogCreate.defaultProps = {
  openDialog: false,
  setOpenDialog: () => {},
  title: null
}
